import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowNavigation = _resolveComponent("ArrowNavigation")!

  return (_openBlock(), _createBlock(_component_ArrowNavigation, {
    textLeft: _ctx.$t('navigation.next_verse'),
    textMiddle: _ctx.overviewText,
    textRight: _ctx.$t('navigation.previous_verse'),
    leftLink: _ctx.leftLink,
    middleLink: _ctx.middleLink,
    rightLink: _ctx.rightLink
  }, null, 8, ["textLeft", "textMiddle", "textRight", "leftLink", "middleLink", "rightLink"]))
}